import SlidesView from "@features/media-academy/view/slides-view";

const Slides = () => {
  return <SlidesView />;
};

export default Slides;
